import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// * State objects
let driver

// * Load from localstorage
if (localStorage.getItem('driver')) {
  driver = JSON.parse(localStorage.getItem('driver'))
} else {
  driver = {
    id: '',
    name: ''
  }
}

export default new Vuex.Store({
  state: {
    driver: driver,
    route: {
      id: '',
      category: '',
      from: '',
      to: ''
    }
  },
  mutations: {
    // * update driver
    updateDriver: (state, driver) => {
      state.driver.id = driver.id
      state.driver.name = driver.name

      localStorage.setItem('driver', JSON.stringify(driver))
    },
    // * update route
    updateRoute: (state, route) => {
      state.route.id = route.id
      state.route.category = route.category
      state.route.from = route.from
      state.route.to = route.to
    }
  },
  actions: {}
})
